import script from "./TimestampEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TimestampEditor.vue?vue&type=script&setup=true&lang=js"

import "./TimestampEditor.vue?vue&type=style&index=0&id=58495b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58495b08"]])

export default __exports__